/**
 * Builds the Google consent URL for granting Coefficient offline access to Google Sheets.
 * Generalized from the addon's original `getOAuthAuthorizationUrlForGSheets` so both webapp
 * and the addon can supply their own `clientId`/`redirectUri` without this package reaching
 * into either app's config module.
 */
export const buildGSheetOAuthAuthorizationUrl = ({
  clientId,
  redirectUri,
  email,
  oauthAttemptId,
}: {
  clientId: string;
  redirectUri: string;
  email: string;
  oauthAttemptId: string;
}): string => {
  const params = {
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "https://www.googleapis.com/auth/spreadsheets",
    state: JSON.stringify({ email, oauth_attempt_id: oauthAttemptId }),
    access_type: "offline",
    prompt: "consent",
  };
  return "https://accounts.google.com/o/oauth2/auth?" + new URLSearchParams(params).toString();
};
